import React from "react";

class Jane extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="painting-item" id="jane">
                <div className="painting-item-left">
                    <div className="painting-container">
                        <img src='/alphabet-2013/jane.webp' className="painting-image"></img>
                        <div className="painting-title">
                            Jane, Joan, Janis... 1969
                            <br/>
                            Avril 2013
                        </div>
                    </div>
                </div>
                <div className="painting-item-right">
                    <h3 className="painting-text-subtitle">Jane, Joan, Janis... 1969</h3>
                    <p className="painting-item-text">
                    </p>
                </div>
            </div>
        );
    }

}

export {Jane};
